<template>
  <nav id="navs" class="navbar navbar-default no-btm" style="background:rgba(44, 49, 52, 0.7);">
    <div class="container">
      <div class="col-md-3">
        <router-link class="top-mmenu" :to="{ name: 'home'}">
          <img :src="config.url + config.img_url + config.id + '/' + state.info.logo" style="max-height: 40px;max-width: 100%;" alt="logotype">
        </router-link>
      </div>
      <div class="col-md-6 vcenter text-center">
        <router-link class="top-mmenu" :to="{ name: 'home'}">Главная</router-link>
        <router-link v-if="state.payments.length > 0 || state.shippings.length > 0 || state.pickups.length > 0" class="top-mmenu"
          :to="{ name: 'DeliveryAndPayment'}">Доставка и оплата</router-link>
        <router-link v-if="state.sales.length > 0" class="top-mmenu" :to="{ name: 'Sales'}">Акции</router-link>
        <router-link class="top-mmenu" :to="{ name: 'contact'}">Контакты</router-link>
      </div>
      <div class="col-md-3 phone text-right">
        <p class="phone">{{ state.info.phone }}</p>
        <p style="margin-top: 7px;">Работаем с {{ state.info.start_h }}:{{minutes(state.info.start_m)}} до {{ state.info.end_h }}:{{minutes(state.info.end_m)}}</p>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    computed: {
      state() {
        return this.$store.state
      },
      config() {
        return this.$store.state.config
      },
    },
    methods: {
      minutes(data) {
        var count = String.valueOf(Math.abs(data)).length
        if(count < 2) {
          return '0' + data;
        } else {
          return data;
        }
      },
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/header.vue